import { gql } from '@graphql/__generated__';

export const GET_APPRAISAL_HISTORY = gql(/* GraphQL */ `
  query GetAppraisalHistory($propertyId: uuid!) {
    appraisals(
      where: { property_id: { _eq: $propertyId } }
      order_by: { created_at: desc }
    ) {
      id
      min
      max
      value
      created_at
      updated_at
    }
  }
`);

export const GET_PROPERTY_APPRAISABLE = gql(/* GraphQL */ `
  query GetPropertyAppraisable($propertyId: uuid!) {
    property_appraisable(property_id: $propertyId) {
      appraisable {
        result
        errors {
          path
        }
      }
    }
  }
`);
